import { Body1, Caption, formatDateWithCustomFormat, H6, colorsLight } from "@coherehealth/common";
import { Grid, IconButton } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import { makeStyles } from "tss-react/mui";
import { useMemo } from "react";

type UploadedFileItemProps = {
  onDelete: () => void;
  fileName: string;
  userName: string | undefined;
};

const useStyles = makeStyles()((theme) => ({
  h6: {
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(3),
  },
  caption: {
    marginTop: theme.spacing(1),
    color: colorsLight.font.secondary,
  },
}));

const UploadedFileItem = ({ onDelete, userName, fileName }: UploadedFileItemProps) => {
  const [date, time, period] = useMemo(() => {
    return formatDateWithCustomFormat(new Date(), "yyyy/MM/dd hh:mm:ss a").split(" ");
  }, []);
  const { classes } = useStyles();
  return (
    <>
      <H6 className={classes.h6}>Files</H6>
      <Grid container flexDirection="row" justifyContent="space-between">
        <Grid style={{ width: "349px" }}>
          <Body1>{fileName}</Body1>
          <Caption className={classes.caption}>{`Uploaded on ${date} at ${time} ${period} ${
            userName ? `by ${userName}` : ""
          }`}</Caption>
        </Grid>
        <Grid container flexDirection="column" flex="0" justifyContent="center">
          <Grid>
            <IconButton aria-label="delete" size="small" data-testid="deleteCsvFileButton" onClick={onDelete}>
              <DeleteIcon />
            </IconButton>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};
export default UploadedFileItem;
